const STAMP_WIDTH = 8;
// Birds
const birdImages = [
  require('url:../src/assets/atmosphere/nature/stamp01.png'),
  require('url:../src/assets/atmosphere/nature/stamp02.png'),
  require('url:../src/assets/atmosphere/nature/stamp03.png'),
];
// Whales
const whaleImages = [
  require('url:../src/assets/atmosphere/underwater/whale01.png'),
  require('url:../src/assets/atmosphere/underwater/whale02.png'),
  require('url:../src/assets/atmosphere/underwater/whale03.png'),
];
// Scratches
const scratchImages = [
  require('url:../src/assets/atmosphere/hiphop/scratch01.png'),
  require('url:../src/assets/atmosphere/hiphop/scratch02.png'),
  require('url:../src/assets/atmosphere/hiphop/scratch03.png'),
];
// Yo
const yoImages = [require('url:../src/assets/atmosphere/hiphop/yo.png')];
// Japanese seal
const sealImages = [require('url:../src/assets/atmosphere/japan/seal01.png')];

class BrushStamps {
  constructor() {
    this.stampImages = {};
  }

  loadImages(imageUrls) {
    const images = [];
    for (const url of imageUrls) {
      const image = new Image();
      image.src = url;
      images.push(image);
    }
    return images;
  }

  load() {
    this.stampImages = {
      bird: this.loadImages(birdImages),
      whale: this.loadImages(whaleImages),
      scratch: this.loadImages(scratchImages),
      yo: this.loadImages(yoImages),
      seal: this.loadImages(sealImages),
    };
  }

  draw(ctx, x, y, color, stampName) {
    // If there is a specific stamp
    if (this.stampImages[stampName]) {
      const stampCollection = this.stampImages[stampName];
      const stamp =
        stampCollection[
          Math.round(Math.random() * (stampCollection.length - 1))
        ];
      const imgW = stamp.width;
      const imgH = stamp.height;
      let scale = Math.random() * 0.25 + 0.2;
      // Translate
      ctx.translate(x, y);
      // Rotate
      const angle = (Math.random() * Math.PI) / 2 - Math.PI / 4;
      ctx.globalAlpha = 0.9;
      ctx.rotate(angle);
      ctx.drawImage(
        stamp,
        (-imgW / 2) * scale,
        (-imgH / 2) * scale,
        imgW * scale,
        imgH * scale
      );
      // Revert the rotation
      ctx.rotate(-angle);
      // Revert the translate
      ctx.translate(-x, -y);
    } else {
      // Else, we draw a circle
      ctx.globalAlpha = 0.9;
      ctx.beginPath();
      ctx.arc(x, y, STAMP_WIDTH * SCALE, 0, 2 * Math.PI);
      ctx.fillStyle = color;
      ctx.fill();
    }
  }
}
export { BrushStamps };
